import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Uploads a large installer straight from the browser to storage, with a progress bar, instead
// of through the release form's one multipart POST - which can time out long before a 300 MB
// file finishes. Choosing a file starts the upload immediately; the form's submit button is
// disabled while any such upload on the page is still running. Once it finishes, the file input
// (now useless - the browser cannot "re-attach" a file to a plain submit) is replaced by a
// hidden field carrying the blob's signed_id, so the form post itself only ever carries that
// short string. Talks to Admin::DirectUploadsController, not Rails' own (disabled) Active
// Storage routes - see config/application.rb for why those are off.
export default class extends Controller {
  static targets = ["input", "bar", "status"]
  static values = { url: String }

  change() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const fieldName = this.inputTarget.name
    this.inputTarget.removeAttribute("name")
    this.element.dataset.uploading = "true"
    this.toggleForm()
    this.setStatus(`Uploading ${file.name}… 0%`, 0)

    const upload = new DirectUpload(file, this.urlValue, {
      directUploadWillStoreFileWithXHR: (xhr) => {
        xhr.upload.addEventListener("progress", (event) => {
          const percent = Math.round((event.loaded / event.total) * 100)
          this.setStatus(`Uploading ${file.name}… ${percent}%`, percent)
        })
      }
    })

    upload.create((error, blob) => {
      delete this.element.dataset.uploading
      this.toggleForm()

      if (error) {
        this.inputTarget.setAttribute("name", fieldName)
        this.setStatus(error, 0, true)
        return
      }

      const hidden = document.createElement("input")
      hidden.type = "hidden"
      hidden.name = fieldName
      hidden.value = blob.signed_id
      this.inputTarget.insertAdjacentElement("afterend", hidden)
      this.setStatus(`Uploaded ${file.name}`, 100)
    })
  }

  setStatus(text, percent, isError = false) {
    this.statusTarget.textContent = text
    this.statusTarget.classList.toggle("direct-upload-error", isError)
    this.barTarget.style.width = `${percent}%`
  }

  // Blocks the form's submit button while this or any sibling upload on the same form is
  // still running, so a Save click cannot race ahead of a signed_id that is not ready yet.
  toggleForm() {
    const form = this.element.closest("form")
    if (!form) return
    const submit = form.querySelector('[type="submit"]')
    if (submit) submit.disabled = form.querySelectorAll("[data-uploading]").length > 0
  }
}
